<script>
import DailyRain from "@/views/count/rain/DailyRain.vue";
import MonthlyRain from "@/views/count/rain/MonthlyRain.vue";
import AnnualRain from "@/views/count/rain/AnnualRain.vue";
import RiverWaterRegime from "@/views/count/rain/RiverWaterRegime.vue";
import ReservoirWaterRegime from "@/views/count/rain/ReservoirWaterRegime.vue";
export default {
  name: "rain",
  components: { DailyRain, MonthlyRain, AnnualRain, RiverWaterRegime, ReservoirWaterRegime },
  data() {
    return {
      period: 'sksq'
    }
  },
}
</script>

<template>
  <el-container style="padding: 20px;">
    <el-tabs v-model="period" @tab-click="" style="width: 100%;">
      <el-tab-pane label="水库水情报表" name="sksq">
        <reservoir-water-regime></reservoir-water-regime>
      </el-tab-pane>
      <el-tab-pane label="河道水情报表" name="hdsq">
        <river-water-regime></river-water-regime>
      </el-tab-pane>
      <el-tab-pane label="雨情日报表" name="day">
        <daily-rain></daily-rain>
      </el-tab-pane>
      <el-tab-pane label="雨情月报表" name="month">
        <MonthlyRain></MonthlyRain>
      </el-tab-pane>
      <el-tab-pane label="雨情年报表" name="year">
        <annual-rain></annual-rain>
      </el-tab-pane>
    </el-tabs>
  </el-container>
</template>

<style scoped>
/* 按钮样式 */
::v-deep .queryButton {
  font-family: PingFang SC;
  font-size: 1.4rem;
  font-weight: normal;
  font-stretch: normal;
  letter-spacing: 0rem;
  border-radius: 0.5rem;
  margin-left: 1.5rem;
}

::v-deep .queryButtonPadding {
  padding-left: 2rem;
  padding-right: 2rem;
}

::v-deep .qDcBtn {
  position: absolute;
  right: 4rem;
}

::v-deep .qDcImg {
  width: 1.2rem;
  height: 1.2rem;
}
</style>